/* Enlarge descriptions only within their existing line and card dimensions. */
(() => {
  if (window.ortheviaDescriptionFit) return;
  window.ortheviaDescriptionFit = true;
  const selector = '#CartDrawer #cart-drawer-upsell .orthevia-offer-description';
  const originalStyles = new WeakMap();
  let frame;

  function fitDescriptions() {
    const drawer = document.querySelector('#CartDrawer .drawer__inner');
    if (!drawer || !drawer.clientWidth) return;
    const descriptions = [...document.querySelectorAll(selector)];
    for (const description of descriptions) {
      if (!originalStyles.has(description)) {
        originalStyles.set(description, description.getAttribute('style'));
      }
      const original = originalStyles.get(description);
      if (original === null) description.removeAttribute('style');
      else description.setAttribute('style', original);
    }
    for (const description of descriptions) {
      const bounds = description.getBoundingClientRect();
      if (!bounds.width || !bounds.height) continue;
      const card = description.closest('.cart-drawer-upsell-list-item');
      const cardHeight = card.getBoundingClientRect().height;
      const overflow = drawer.scrollHeight - drawer.clientHeight;
      const computed = getComputedStyle(description);
      const fontSize = parseFloat(computed.fontSize);
      const lineHeight = computed.lineHeight;
      let fits = false;
      for (const increase of [0.5, 0.25]) {
        description.style.setProperty('line-height', lineHeight, 'important');
        description.style.setProperty('font-size', `${fontSize + increase}px`, 'important');
        const enlarged = description.getBoundingClientRect();
        fits = Math.abs(enlarged.height - bounds.height) < 0.1
          && Math.abs(enlarged.width - bounds.width) < 0.1
          && Math.abs(card.getBoundingClientRect().height - cardHeight) < 0.1
          && description.scrollWidth <= description.clientWidth
          && drawer.scrollHeight - drawer.clientHeight <= overflow;
        if (fits) break;
      }
      if (!fits) {
        const original = originalStyles.get(description);
        if (original === null) description.removeAttribute('style');
        else description.setAttribute('style', original);
      }
    }
  }

  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitDescriptions);
  }

  const cart = document.querySelector('cart-drawer');
  if (!cart) return;
  new MutationObserver(schedule).observe(cart, { childList: true, subtree: true, characterData: true });
  new ResizeObserver(schedule).observe(cart);
  window.addEventListener('resize', schedule);
  document.fonts.ready.then(schedule);
  schedule();
})();
